// extracted by mini-css-extract-plugin
module.exports = {"Page":"AddAlreadyLocation_Page__3odkj"};